import React from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import {
  type PreviousSurcharge,
  type SurchargeDates,
  isSurchargeDatesDone,
} from '../tabs/surcharges/previousSurcharges';

import CopySurchargeDatesRow, { type SurchargeDatesChange } from './CopySurchargeDatesRow';

type CopySurchargeDatesStepProps = {
  datesByKey: Record<string, SurchargeDates>;
  nothingToCopy: boolean;
  onDatesChange: SurchargeDatesChange;
  toDate: Array<PreviousSurcharge>;
};

export default function CopySurchargeDatesStep({
  datesByKey,
  nothingToCopy,
  onDatesChange,
  toDate,
}: CopySurchargeDatesStepProps) {
  const everyDone = toDate.every(({ key }) => isSurchargeDatesDone(datesByKey[key]));

  return (
    <>
      <Typography sx={{ mt: 2 }} variant="subtitle2">
        Dates for each surcharge period
      </Typography>
      <Typography color="text.secondary" variant="body2">
        Salesforce is missing dates for these, so set them here. Where this Opportunity has travel dates, they are
        filled in already. Skip any you don&apos;t know yet: it won&apos;t be copied, so add it on the Surcharges tab
        later.
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Salesforce name</TableCell>
            <TableCell>Days</TableCell>
            <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
              Sell AUD
            </TableCell>
            <TableCell>From</TableCell>
            <TableCell>To</TableCell>
            <TableCell>Skip</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {toDate.map(({ key, period }) => (
            <CopySurchargeDatesRow
              dates={datesByKey[key]}
              key={key}
              onDatesChange={onDatesChange}
              period={period}
              periodKey={key}
            />
          ))}
        </TableBody>
      </Table>
      {!everyDone && (
        <Typography color="error" sx={{ mt: 1 }} variant="body2">
          Set From and To, or skip, for each surcharge period to continue.
        </Typography>
      )}
      {everyDone && nothingToCopy && (
        <Typography color="error" sx={{ mt: 1 }} variant="body2">
          Every surcharge period is skipped. Untick Surcharges on What to copy instead.
        </Typography>
      )}
    </>
  );
}
